import { useEffect } from "react";
import { useViewerSlice } from "../../../../store/slices/viewer/viewerSlice";
import fitToScreen from "../../../../pages/Viewer/Images/fullScreen.svg";

const FullScreen = () => {
  const { showDomSpeaker } =
    useViewerSlice();

  const fullScreenVideo = async () => {
    const elem: any = document.getElementById("video-container");
    if(elem){
      const video = elem.getElementsByTagName('video');
      video[0]?.removeAttribute('controls');
    }
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };


  useEffect(() => {
    const elem: any = document.getElementById('video-container');
    if (!elem) return;
    
    elem.addEventListener('fullscreenchange', fullscreenchanged);

    const excludedElementTypes = ['input', 'textarea', 'select'];
    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement;
      if (excludedElementTypes.includes(target.tagName.toLowerCase())) {
        return;
      }
      if (event.key === 'f' || event.key === 'F') {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else {
          elem.requestFullscreen();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      elem.removeEventListener('fullscreenchange', fullscreenchanged);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const fullscreenchanged = () => {
    const videoElem: HTMLVideoElement | null = document.getElementById(
      'main-stream-video',
    ) as HTMLVideoElement | null;

    if (!videoElem) return;

    if (
      document.fullscreenElement &&
      document.fullscreenElement.id === 'video-container'
    ) {
      videoElem.controls = true;
    } else {
      videoElem.controls = false;
    }
  };


  return (
    <div
      onClick={fullScreenVideo}
      className={`top-menu-button-item fullscreen-button ${showDomSpeaker ? "disableddiv" : ""
        }`}
    >
      <img className="fullscreen-img" src={fitToScreen} alt="" />
      <span>FullScreen Video</span>
    </div>
  );
};

export default FullScreen;